var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssueConfirmedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "085C9187-3218-4C59-AF14-CC20ED14F379") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.0210981,36.4441906 L34.821127,40.556979 C36.0664335,41.3107171 37.5902954,40.1964956 37.2625832,38.787333 L35.4601659,31.0533246 L41.4736854,25.8427003 C42.5715214,24.8923349 41.9816393,23.0899177 40.5397055,22.9752184 L32.625455,22.3034084 L29.5285744,14.9954259 C28.9714636,13.6681914 27.0707327,13.6681914 26.5136219,14.9954259 L23.4167412,22.2870228 L15.5024908,22.9588328 C14.0605569,23.0735321 13.4706749,24.8759493 14.5685109,25.8263147 L20.5820304,31.036939 L18.7796131,38.7709474 C18.4519009,40.1801099 19.9757628,41.2943315 21.2210693,40.5405934 L28.0210981,36.4441906 L28.0210981,36.4441906 Z M27.972,0 C12.516,0 0,12.544 0,28 C0,43.456 12.516,56 27.972,56 C43.456,56 56,43.456 56,28 C56,12.544 43.456,0 27.972,0 Z M27.9999995,50.3999991 C15.6239997,50.3999991 5.5999999,40.3759993 5.5999999,27.9999995 C5.5999999,15.6239997 15.6239997,5.5999999 27.9999995,5.5999999 C40.3759993,5.5999999 50.3999991,15.6239997 50.3999991,27.9999995 C50.3999991,40.3759993 40.3759993,50.3999991 27.9999995,50.3999991 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7_Issue-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comments-Entered",
    transform: "translate(-904.000000, -172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Classify-Asset-Class-Header",
    transform: "translate(0.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Results-Detail-/-Icon-/-Issue-Confirmed",
    transform: "translate(904.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Issue-Confirmed-Icon",
    fill: "#398F90",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueConfirmedIcon);
export default __webpack_public_path__ + "static/media/issue-confirmed-icon.60d7870c11ae425666f8cb6e8628256d.svg";
export { ForwardRef as ReactComponent };